// @noflow
export type { Props as HouseProps } from './House'
export { default as House } from './House'
